export default __webpack_public_path__ + "static/centerPhone-0e7db26cc809039b6561a85924f32ed0.png";